import React, { useEffect, useState } from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getTutorGroupCategoryData, getTutorGroupSubCategoryData, getTutorBookedStudentList } from '../../../Redux/action/TutorAction'
import { getProfileData, getSubCategoryData } from '../../../Redux/action/MasterAction'
import { ValidationError } from 'yup'
import { useFormik } from 'formik'
import axios from 'axios'
import toast from 'react-hot-toast'
import * as Yup from "yup";
import Beatloader from '../../../Common/BeatLoader'
import { doc, collection, getDoc, setDoc, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firbase";
import { jwtDecode } from 'jwt-decode'

const host = process.env.REACT_APP_API_SERVER

const TutorMyStudentsGroup = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [show, setShow] = useState(false);

    useEffect(() => {
        dispatch(getTutorGroupCategoryData());


    }, [])


    const {
        //GROUP category
        loadingTutorGroupCategoryDataListApi,
        TutorGroupCategoryDataListApiData,
        TutorGroupCategoryDataListApiError,

        //GROUP category
        loadingTutorGroupSubCategoryDataListApi,
        TutorGroupSubCategoryDataListApiData,
        TutorGroupSubCategoryDataListApiError,


        loadingTutorBookedStudentListApi,
        TutorBookedStudentListApiData,
        TutorBookedStudentListApiError

    } = useSelector(state => state?.TutorReducer);







    const formik = useFormik({
        initialValues: {
            teaching_type_id: '1',
            category_id: '',
            subject_id: ''
        },
        validationSchema: Yup.object().shape({
            category_id: Yup.string().required("Class/Grade/General is required."),
            subject_id: Yup.string().required("Subject is required."),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            dispatch(getTutorBookedStudentList(values));
            setShow(true)
        },
    });

    const handleGroupClassChange = (e) => {
        const id = e.target.value
        formik.setFieldValue('subject_id', '')
        dispatch(getTutorGroupSubCategoryData(id))
        if (id == '') {
            dispatch(getTutorGroupSubCategoryData('0'))
        }
        else {
            dispatch(getTutorGroupSubCategoryData(id))
        }
    }
    const handleChatNavigation = async (id) => {
        try {
            const authToken = localStorage.getItem('tutor-token');
            const decoded = jwtDecode(authToken);
            const participant1 = decoded?.user?.id;
            const participant2 = id;


            if (!participant1 || !participant2) {
                toast.error("Invalid participant IDs. Unable to navigate to chat.");
                return;
            }

            const data = { participant1, participant2 };

            const response = await axios.post(`${host}/api/web/create-chatroom`, data, {
                headers: {
                    "x-auth-token": authToken,
                },
            });

            if (response.data?.statusCode === 200) {
                const chatroomId = response.data.data.chatroomId;
                navigate(`/tutor/chat/${btoa(chatroomId)}`);
            } else {
                toast.error(response.data?.message || "Failed to create chatroom!");
            }
        } catch (error) {
            console.error("Error navigating to chat:", error);
            toast.error("An error occurred while creating the chatroom. Please try again!");
        }
    };
    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Students
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    <ul className="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <Link
                                                className="nav-link"
                                                to='/tutor/my-students'
                                            >
                                                One To One
                                            </Link>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="profile-tab"
                                                data-bs-toggle="tab"
                                                data-bs-target="#profile"
                                                type="button"
                                                role="tab"
                                                aria-controls="profile"
                                                aria-selected="false"
                                            >
                                                Group Tutoring
                                            </button>
                                        </li>
                                    </ul>
                                    <div className="tab-content my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            <form onSubmit={formik.handleSubmit} >
                                                <div className="row my-4">
                                                    <div className="col-lg-4 col-md-4">
                                                        <label htmlFor="" className="label">
                                                            Select Class/Grade/General
                                                        </label>
                                                        <br />
                                                        <select className="select-form" name='category_id' onChange={(e) => {
                                                            formik.handleChange(e);
                                                            handleGroupClassChange(e);
                                                        }}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.category_id}>
                                                            <option value=""> --Select Class--</option>
                                                            {TutorGroupCategoryDataListApiData?.map((data) => (
                                                                <option value={data?.id}>{data?.is_other ? data?.other_name : data?.name}</option>
                                                            ))}
                                                        </select>
                                                        <div className="help-block with-errors">
                                                            {formik.touched.category_id && formik.errors.category_id ? (
                                                                <div className='text-danger'>{formik.errors.category_id}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4">
                                                        <label htmlFor="" className="label">
                                                            Select Subject
                                                        </label>
                                                        <br />
                                                        <select className="select-form" name='subject_id' onChange={(e) => {
                                                            formik.handleChange(e);

                                                        }}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.subject_id}>
                                                            <option value="">
                                                                --Select Subject--
                                                            </option>
                                                            {TutorGroupSubCategoryDataListApiData?.map((data) => (
                                                                <option value={data?.id}>{data?.is_other ? data?.other_name : data?.name}</option>
                                                            ))}
                                                        </select>
                                                        <div className="help-block with-errors">
                                                            {formik.touched.subject_id && formik.errors.subject_id ? (
                                                                <div className='text-danger'>{formik.errors.subject_id}</div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2 col-md-2">
                                                        <input
                                                            disabled={loadingTutorBookedStudentListApi}
                                                            type="submit"
                                                            defaultValue="search"
                                                            className="btn btn-primary srch-btn w-100"
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                            {show &&
                                                <div className="table-responsive">
                                                    {loadingTutorBookedStudentListApi ?
                                                        <Beatloader />
                                                        :
                                                        <table className="table table-light">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">S.No.</th>
                                                                    <th scope="col">Name</th>
                                                                    <th scope="col">Subject</th>
                                                                    <th scope="col">Course Name</th>
                                                                    <th scope="col">Start date</th>
                                                                    <th scope="col">End date</th>
                                                                    <th scope="col">Action</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {TutorBookedStudentListApiData?.length > 0 ?
                                                                    TutorBookedStudentListApiData?.map((data, index) => (
                                                                        <tr>
                                                                            <th>{index + 1}</th>
                                                                            <td>
                                                                                <div>
                                                                                    {/* <span className="table-img">
                                                                                        <img
                                                                                            src="/assets/img/user/user1.jpg"
                                                                                            className="img-fluid"
                                                                                        />
                                                                                    </span> */}
                                                                                    <span className="ms-2">{data?.student?.name}</span>
                                                                                </div>
                                                                            </td>
                                                                            <td>{data?.course?.subcategory?.name}</td>
                                                                            <td>{data?.course?.name}</td>
                                                                            <td>{data?.batchData?.batch_start_date}</td>
                                                                            <td>{data?.batchData?.batch_end_date}</td>
                                                                            <td>
                                                                                <div>
                                                                                    <span>
                                                                                        <a onClick={() => { handleChatNavigation(data?.student?.id) }} className="chat-link">
                                                                                            <i
                                                                                                className="fa-solid fa-comment"
                                                                                                data-toggle="tooltip"
                                                                                                title="chat"
                                                                                            />
                                                                                        </a>
                                                                                    </span>
                                                                                    <span className="ms-2">
                                                                                        <Link
                                                                                            to={`/tutor/my-schedule-group-details/${btoa(data?.id)}`}
                                                                                            className="view-link"
                                                                                        >
                                                                                            <i
                                                                                                className="fa-solid fa-eye"
                                                                                                data-toggle="tooltip"
                                                                                                title="view schedule"
                                                                                            />
                                                                                        </Link>
                                                                                    </span>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                    :
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td>No Data</td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    }
                                                </div>

                                            }
                                        </div>

                                    </div>
                                </div>
                            </main>


                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Booking View Modal */}
                <div
                    className="modal fade"
                    id="bookingModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Booking
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <h6 className="text-primary">Start Date: 3-11-2024</h6>
                                <h6 className="text-primary">Time Slot: 14:00PM - 15PM</h6>
                                <h6 className="text-primary">Topic Details: Chapter 1</h6>
                            </div>
                            <div className="modal-footer d-flex justify-content-start">
                                {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                                <button type="button" className="btn btn-primary">
                                    Join Meeting
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default TutorMyStudentsGroup